import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginByNonceGuardService implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const nonceId = route.paramMap.get('nonceId');

    if (!nonceId) {
      return of(true);
    }

    return new Observable<boolean | UrlTree>(observer => {
      this.auth.loginUserByNonceId(nonceId).subscribe({
        next: res => {
          if (res) {
            observer.next(this.router.parseUrl('/dashboard'));
          }
          observer.complete();
        },
        error: () => {
          observer.next(this.router.parseUrl('/login'));
          observer.complete();
        },
      });
    });
  }
}
